export const columns = [
  { id: 'date', label: 'DATA DA MOVIMENTAÇÃO', minWidth: 150 },
  { id: 'createdAt', label: 'DATA DA CRIAÇÃO', minWidth: 150 },
  { id: 'type', label: 'TIPO DE MOVIMENTAÇÃO', minWidth: 120 },
  { id: 'paymentTotal', label: 'VALOR DA TRANSAÇÃO', minWidth: 120 },
  { id: 'points', label: 'PONTOS', minWidth: 80 },
  { id: 'expiration-date', label: 'VALIDADE', minWidth: 80 },
  { id: 'channel', label: 'CANAL', minWidth: 80 },
  { id: 'order', label: 'PEDIDO', minWidth: 120 },
  { id: 'tier', label: 'TIER/LEVEL', minWidth: 70 },
  { id: 'partial-value', label: 'SALDO PARCIAL', minWidth: 80 },
  { id: 'store', label: 'LOJA', minWidth: 50 },
  { id: 'employee-code', label: 'CÓDIGO FUNCIONÁRIO', minWidth: 80 }
]
